import React from 'react';
import './Modal.css';
import cross from "../../assets/cross.png";
import { FaGithub, FaExternalLinkAlt } from 'react-icons/fa';

const Modal = ({skill, learning, certificate, heading, description, technologies, image, codeLink, demoLink, closeModal}) => {
  // Support both old skill modal and new project modal
  const isProjectModal = heading !== undefined;

  return (
    <div className='model-backdrop' onClick={closeModal}>
      <div className='model-box' onClick={(e) => e.stopPropagation()}>
        <img src={cross} alt='cross-button' height="40px" width="40px" onClick={closeModal} className='modal-close-button' />
        <div className='model-content'>
          {isProjectModal ? (
            // Project Modal Content
            <>
              <h2 className='model-heading'>{heading}</h2>
              {image && (
                <div className='modal-project-image'>
                  <img src={image} alt={heading} />
                </div>
              )}
              <section className='modal-project-section'>
                <h3>Description</h3>
                <p>{description}</p>
              </section>
              <section className='modal-project-section'>
                <h3>Technologies</h3>
                <div className='modal-tech-stack'>
                  {technologies && technologies.map((tech, index) => (
                    <div key={index} className='tech-badge'>
                      <span className='tech-icon'>{tech.icon}</span>
                      <span className='tech-name'>{tech.name}</span>
                    </div>
                  ))}
                </div>
              </section>
              <div className='modal-project-links'>
                {codeLink && (
                  <a href={codeLink} target='_blank' rel='noreferrer' className='modal-link'>
                    <FaGithub /> View Code
                  </a>
                )}
                {demoLink && (
                  <a href={demoLink} target='_blank' rel='noreferrer' className='modal-link'>
                    <FaExternalLinkAlt /> Live Demo
                  </a>
                )}
              </div>
            </>
          ) : (
            // Skill Modal Content (original)
            <>
              <h2 className='model-heading'>{skill}</h2>
              <section>
                <h3>How I learnt?</h3>
                <p>{learning}</p>
                {certificate && (
                  <div className='modal-certificate-container'>
                    <img src={certificate} alt={`${skill}-certificate`} height="auto" width="300px" />
                  </div>
                )}
              </section>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default Modal
